import React from 'react'

const Button = ({ text, onClick, style }) => (
  <button style={style} onClick={onClick}>
    {text}
  </button>
)

const buttonStyles = {
  backgroundColor: 'purple',
  padding: 10,
  border: 'none',
  borderRadius: 5,
  margin: '3px auto',
  cursor: 'pointer',
  fontSize: 22,
  color: 'white'
}

class Header extends React.Component {
  render() {
    const {
      welcome,
      title,
      subtitle,
      author: { firstName, lastName },
      date,
    } = this.props.data

    return (
      <header>
        <div className="header-wrapper">
          <h1>{welcome}</h1>
          <h2>{title}</h2>
          <h3>{subtitle}</h3>
          <p>
            {firstName} {lastName}
          </p>
          <small>{date}</small>
          <p>Select a country for your next holiday</p>
        </div>
      </header>
    )
  }
}

class App extends React.Component {
  state = {
    loggedIn: false,
  }

  handleLogin = () => {
    this.setState({ loggedIn: !this.state.loggedIn })
  }

  componentDidMount() {
    document.title = "Conditional Rendering"
  }
  
  render() {
    const data = {
      welcome: 'Challenges in React',
      title: 'Getting Hot with React',
      subtitle: 'Javascript Rocks',
      author: {
        firstName: 'sauron',
        lastName: 'ravi'
      },
      date: '9 Nov, 2053'
    }
    // here comes conditional rendering

    let status, text

    if (this.state.loggedIn) {
      status = <h3> Here awesomeness happenning </h3>
      text = 'Logout'
    } else {
      status = <h3> Please perform Login </h3>
      text = 'Login'
    }

    return (
      <div className="conditionally-rendered-app">
        <Header data={data} />
        {status}
        <Button text={text} style={buttonStyles} onClick={this.handleLogin} />
      </div>
    )
  }
}

export default App